module.exports = __webpack_public_path__ + "img/cancle.06f3e15.svg";